import Error404 from '@/components/error/404';
import Explore from '@/pages/explore';
import type { RouteObject } from 'react-router-dom';

export const exploreRoutes: RouteObject[] = [
  {
    path: 'explore',
    errorElement: <Error404 />,
    element: <Explore />,
  },
];
